import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const holidayService = {

    getHoliday: async () => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/holiday`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    
    createHoliday: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/holiday`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    updatedHoliday: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "PUT",
            url: `/api/holiday`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    deleteHoliday: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "DELETE",
            url: `/api/holiday/${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

};

export default holidayService;